export default __webpack_public_path__ + "static/media/scooter_active.72af3875.svg";